import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";
import CheckCircleIcon from "@ps-design-system/icons/CheckCircle/CheckCircle20";

import type { OwnerListing } from "../../../services/listings.service";

import { LISTING_TYPE_LABELS } from "./DateBasedPricingListingDialog.consts";

type DateBasedPricingListingOptionProps = {
  isSelected: boolean;
  listing: OwnerListing;
  onSelect: (listingId: string) => void;
};

/** A selectable space row in the "Set date pricing" picker. */
const DateBasedPricingListingOption = ({
  isSelected,
  listing,
  onSelect,
}: DateBasedPricingListingOptionProps) => {
  const listingTypeLabel =
    LISTING_TYPE_LABELS[listing.use_type as keyof typeof LISTING_TYPE_LABELS];

  return (
    <button
      aria-checked={isSelected}
      className={`tw-flex tw-w-full tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-16 tw-rounded-2 tw-border tw-border-solid tw-bg-base-white tw-px-12 tw-py-8 tw-text-left ${
        isSelected ? "tw-border-gray-900" : "tw-border-gray-400"
      }`}
      data-testid={`date-based-pricing-dialog-listing-${listing._id}`}
      onClick={() => onSelect(listing._id)}
      role="radio"
      type="button"
    >
      <span className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-4">
        <Text typeface="body-2-m" className="tw-truncate tw-text-gray-900">
          {listing.title}
        </Text>
        {listingTypeLabel && (
          <Text typeface="body-1-long" className="tw-text-gray-600">
            <FormattedMessage {...listingTypeLabel} />
          </Text>
        )}
      </span>
      {isSelected && <CheckCircleIcon className="tw-shrink-0" />}
    </button>
  );
};

export { DateBasedPricingListingOption };
